/**
 * @fileoverview LoadingSpinner Component - Animated loading indicator
 * 
 * Provides a consistent loading spinner interface with:
 * - Animated FontAwesome spinner icon
 * - Optional loading messages
 * - Customizable text content
 * - Consistent styling across application
 * - Accessibility considerations
 * 
 * @component
 * @example
 * <LoadingSpinner message="Loading data..." subMessage="Please wait" />
 * 
 * @requires React
 * @requires ./LoadingSpinner.css
 * 
 * @author By John Bellew - Infinia.ie - last updated 10/07/2025
 */

import React from 'react';
import './LoadingSpinner.css';

/**
 * LoadingSpinner Component
 * 
 * Renders an animated loading spinner with optional message text.
 * 
 * @component
 * @param {Object} props - Component properties
 * @param {string} [props.message='Loading...'] - Primary loading message
 * @param {string} [props.subMessage='Please wait'] - Secondary loading message
 * 
 * @returns {JSX.Element} Animated loading spinner with messages
 */
const LoadingSpinner = ({ message = 'Loading...', subMessage = 'Please wait' }) => {
    return (
        <div className="loading-spinner-container">
            <div className="loading-spinner-content">
                <i className="fas fa-circle-notch fa-spin"></i>
                {/* <span className="loading-message">{message}</span>
                {subMessage && <span className="loading-submessage">{subMessage}</span>} */}
            </div>
        </div>
    );
};

export default LoadingSpinner;
